export default __webpack_public_path__ + "static/media/dra-cindy.2ace9c60.png";